import { useState } from "react";
import { useRecoilValue } from "recoil";
import classNames from "classnames";

import { mediaState } from "../../recoil";
import Header from "./Header";
import Footer from "./Footer";
import Navigation from "./Navigation";
import Login from "../../page/Login";
import { createPortal } from "react-dom";
import { useRecoilState } from "recoil";
import loginFormState from "../../recoil/loginFormState";

const TaneswLoginModal = () => {
    const [loginForm, setLoginForm] = useRecoilState(loginFormState);
    const { open } = loginForm;

    return open ? createPortal(<Login type="tanesw" />, document.body) : null;
};

const MainLayout = ({ children }: any) => {
    const { lg } = useRecoilValue(mediaState);
    const [expanded, setExpanded] = useState(true);

    return (
        <>
            <div className="flex w-screen min-h-screen">
                {lg && <Navigation expanded={expanded} setExpanded={setExpanded} />}
                <div
                    className={classNames(
                        "flex flex-col",
                        lg && (expanded ? "w-[calc(100%-280px)]" : "w-[calc(100%-70px)]"),
                        !lg && "w-full",
                    )}
                >
                    <Header />
                    <main className="flex-1 p-4">{children}</main>
                    <Footer />
                </div>
            </div>

            <TaneswLoginModal />
        </>
    );
};

export default MainLayout;
